import { useState } from 'react';
import Icon, { ICON_HEART, ICON_HEART_FILLED } from '~/components/icon/index.js';

const LoveButton = props => {
	const { loved, icon = ICON_HEART, activeIcon = ICON_HEART_FILLED, isLoading = false } = props;

	const [className, setClassName] = useState('');

	const onClick = e => {
		setClassName('click-effect');
		window.setTimeout(() => {
			setClassName('');
		}, 500);
		props.onClick(e);
	};

	return (
		<button
			type="button"
			className={`item__love u-flex u-relative ${loved && 'game-item__love--selected'} ${
				isLoading ? 'game-item__love--loading' : ''
			} ${className}`}
			onClick={onClick}
			data-at="love-icon"
		>
			<Icon className="item__love-icon" type={loved ? activeIcon : icon} />
			{/* this.props.showCount && (
								<span className="item__love-counter">
									{parseInt(
										gameLikesInfo?.likesViewString || 0,
										10
									) > 0
										? gameLikesInfo?.likesViewString
										: ''}
								</span>
									) */}
		</button>
	);
};

export default LoveButton;
